module.exports = __webpack_public_path__ + "img/2.02ac9a63.png";